import { render, staticRenderFns } from "./Ventilator.vue?vue&type=template&id=17b5feb4&scoped=true&"
import script from "./Ventilator.vue?vue&type=script&lang=js&"
export * from "./Ventilator.vue?vue&type=script&lang=js&"
import style0 from "./Ventilator.vue?vue&type=style&index=0&id=17b5feb4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b5feb4",
  null
  
)

export default component.exports